import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=4cf6a3c2&scoped=true&lang=pug&"
import script from "./radio-group.vue?vue&type=script&lang=js&"
export * from "./radio-group.vue?vue&type=script&lang=js&"
import style0 from "./radio-group.vue?vue&type=style&index=0&id=4cf6a3c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6a3c2",
  null
  
)

export default component.exports